import { Outlet } from 'react-router';

import { useSelectedProjectId } from 'features/projects';

const ManageMasterPage = () => {
  const selectedId = useSelectedProjectId();

  if (selectedId == null) {
    return (
      <div className="max-w-4xl">
        <h1 className="text-2xl font-bold font-display mb-2">Administrar Inmobiliaria</h1>
        <p className="text-sm text-text-muted">
          Selecciona una inmobiliaria desde el sidebar para editar su configuración master o sus subproyectos.
        </p>
      </div>
    );
  }

  return (
    <div className="max-w-5xl">
      <Outlet />
    </div>
  );
};

export default ManageMasterPage;
